import { render, staticRenderFns } from "./DiplomaStudent.vue?vue&type=template&id=83c14a96&"
import script from "./DiplomaStudent.vue?vue&type=script&lang=js&"
export * from "./DiplomaStudent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports